function HelpController(){
	this.className	= "HelpController";
	this.glob		= "/help**";
	this.debug		= false;
};
HelpController.inheritsFrom( StandardController );
HelpController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
HelpController.prototype.on = function(){
	this.configPopupTrigger();
};
HelpController.prototype.configPopupTrigger = function() {
	var state = nav.getState();

	this.$resourcesButton = $('.js-resources-button');

	this.$resourcesButton.on('click', Igloo.$d(this, function($this){
		const subject_title = JSON.parse($this.attr('data-subject-title'));
		const resources = JSON.parse($this.attr('data-resources'));

		this.popup = new AdditionalResourcesPopup({
			values: {
				subject_title,
				resources,
			},
			controller: this
		});
	}));

	if (state.nextHash) {
		const $hash = $(`#${state.nextHash}`);
		if ($hash.length) {
			const $revealer = $hash.parents('.revealer');
			$revealer.addClass('open');

			const $resourceButton = $hash.find('.js-resources-button');
			if ($resourceButton.length) {
				$resourceButton.trigger('click');
			}
		}
	}
}
HelpController.prototype.off = function(){
	if(this.popup) this.popup.destroy();
};